// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakePhoneModel {
    static getAttributeTypeMap() {
        return SimpleIntakePhoneModel.attributeTypeMap;
    }
}
SimpleIntakePhoneModel.discriminator = undefined;
SimpleIntakePhoneModel.additionalProperties = false;
SimpleIntakePhoneModel.attributeTypeMap = [
    {
        "name": "extension",
        "baseName": "extension",
        "type": "string"
    },
    {
        "name": "number",
        "baseName": "number",
        "type": "string"
    },
    {
        "name": "voicemail",
        "baseName": "voicemail",
        "type": "boolean"
    },
];
//# sourceMappingURL=simpleIntakePhoneModel.js.map